import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const ChartWrapper = styled.div`
	.highcharts-plot-band-label {
		&:after {
			content: '';
			position: absolute;
			left: -18px;
			top: 16px;
			width: 0;
			height: 0;
			border-left: 18px solid transparent;
			border-right: 18px solid transparent;
			border-top: 12px solid ${colors.grey3};
		}
	}
`;
